"use strict";

import $ from "jquery";
import {
    default as initMap,
    setDefaultMarkerStyle,
    setActiveMarkerStyle,
    scrollToMarkers,
    centerMap,
    setMarker
} from "./leaflet-map";

let $teasers = [];
let markerModifications = [];
let activeMarker;
let mapObj;

export function initInScope($scope){
    $scope.find('.js-mice-map').each(function () {
        let $mapElement = $(this).find('.js-mice-map__map');
        $teasers = $(this).find('.js-mice-map__teaser');

        let pois = [];
        markerModifications = [];
        activeMarker = null;

        $teasers.each(function () {
            let dataSet = getPredefinedDataset('miceMapPoi', $(this));
            if (dataSet.id && dataSet.lat && dataSet.lng) {
                pois.push(dataSet);
            }
        });

        if ($mapElement.length > 0) {
            import('leaflet').then(function () {
                mapObj = initMap({
                    element: $mapElement[0],
                    clustering: true,
                    mapOptions:  {
                        center: {lat: 47.3768866, lng: 8.541694},
                        zoom: 12,
                        minZoom: 7,
                        maxBounds: [
                            [45.817993, 5.955911],
                            [47.808455, 10.492294]
                        ],
                        maxBoundsViscosity: 1
                    },
                    poiStyles: createPoiStyles(),
                    onActivateMarker,
                    onDeactivateMarker,
                    clusteringOptions: {
                        showCoverageOnHover: false,
                        iconCreateFunction: function(cluster) {
                            return L.divIcon({
                                iconSize: [46, 46],
                                iconAnchor: [23, 23],
                                className: 'marker-cluster',
                                html: '<img src="/static/img/mice/marker-cluster.svg"/><span class="marker-cluster__count">' + cluster.getChildCount() + '</span>'
                            });
                        }
                    },
                    mapLayerDefault: 'aerialMapLayer'
                });

                setMarker(mapObj, pois)

                initMarkerAndTeaserEvents();
            }).catch(function (a, b, c) {
                console.error(a, b, c);
            });
        }
    });
}

function onActivateMarker(marker) {
    // Set modification to activate so the marker doesn't lose active style
    let modification = getMarkerModification(marker.dataId);
    if (modification) {
        modification.mod = 'activate';
    }
    changeTeaserState($teasers, marker.dataId, 'activate');
    activeMarker = marker;

    let $teaser = $teasers.filter(function () {
        return $(this).attr('id') === 'mice-map-teaser-' + marker.dataId;
    });

    if ($teaser.length > 0) {
        window.scrollTo({
            behavior: 'smooth',
            top: $teaser[0].getBoundingClientRect().top -
                document.body.getBoundingClientRect().top -
                20
        });
    }
}

function onDeactivateMarker(marker) {
    // set modification to blur so the focus state can be set again
    let modification = getMarkerModification(marker.dataId);
    if (modification) {
        modification.mod = 'blur';
    }
    changeTeaserState($teasers, marker.dataId, 'deactivate');
    activeMarker = null;
}

function initMarkerAndTeaserEvents() {
    const events = ['mouseover', 'focus'];
    const resetEvents = ['mouseout', 'blur'];

    const markers = mapObj.marker;

    // Map marker events to teaser style
    markers.forEach((marker) => {
        events.forEach((event) => {
            $(marker).on(event, () => {
                let modification = getMarkerModification(marker.dataId);
                if (!modification) {
                    markerModifications.push({ id: marker.dataId, mod: 'focus' });
                } else if (modification.mod === 'blur') {
                    modification.mod = 'focus';
                }

                setActiveMarkerStyle(marker, mapObj);
                changeTeaserState($teasers, marker.dataId, 'activate');
            });
        });

        resetEvents.forEach((event) => {
            $(marker).on(event, () => {
                if ($(this).find(evt.relatedTarget).length === 0) {
                    let modification = getMarkerModification(marker.dataId);
                    if (modification && modification.mod === 'focus') {
                        setDefaultMarkerStyle(marker, mapObj);
                        changeTeaserState($teasers, marker.dataId, 'deactivate');
                        modification.mod = 'blur';
                    }
                }
            });
        });
    });

    // Map teaser events to marker style
    $teasers.each(function () {
        let $teaser = $(this);
        let dataSet = getPredefinedDataset('miceMapPoi', $teaser);

        if (markers) {
            if (dataSet.lat && dataSet.lng && dataSet.tooltipContent) {
                let tooltip = L.tooltip({ content: dataSet.tooltipContent, direction: 'top' });
                let marker = markers.find((m) => m.dataId === dataSet.id);
                if (marker) {
                    marker.bindTooltip(tooltip);
                }
            }

            events.forEach((event) => {
                $teaser.on(event, () => {
                    let marker = markers.find((m) => m.dataId === dataSet.id);
                    if (marker) {
                        let modification = getMarkerModification(marker.dataId);

                        if (!modification) {
                            markerModifications.push({ id: marker.dataId, mod: 'focus' });
                        } else if (modification.mod === 'blur') {
                            modification.mod = 'focus';
                        }

                        setActiveMarkerStyle(marker, mapObj);
                        scrollToMarkers([marker], mapObj, 16);
                    }

                    $teaser.addClass('is-active');
                });
            });

            resetEvents.forEach((event) => {
                $teaser.on(event, (evt) => {
                    if ($(this).find(evt.relatedTarget).length === 0) {
                        let marker = markers.find((m) => m.dataId === dataSet.id);
                        if (marker) {
                            let modification = getMarkerModification(marker.dataId);

                            if (modification && modification.mod === 'focus') {
                                modification.mod = 'blur';
                                setDefaultMarkerStyle(marker, mapObj);
                                $teaser.removeClass('is-active');
                            }

                            if (activeMarker) {
                                scrollToMarkers([activeMarker], mapObj, 16);
                            } else {
                                centerMap(mapObj);
                            }
                        } else {
                            $teaser.removeClass('is-active');
                        }
                    }
                });
            });
        }
    });
}

function changeTeaserState($teasers, markerId, state) {
    let $teaser = $teasers.filter(function () {
        return getPredefinedDataset('miceMapPoi', $(this)).id === markerId;
    });

    if ($teaser.length > 0) {
        if (state === 'activate') {
            $teaser.addClass('is-active');
        } else {
            $teaser.removeClass('is-active');
        }
    }

    return $teaser;
}

function createPoiStyles() {
    return {
        default: {
            default: L.icon({
                iconUrl: '/static/img/mice/marker.svg',
                iconSize: [34, 50],
                iconAnchor: [17, 45],
                tooltipAnchor: [0, -50],
            }),
            active: L.icon({
                iconUrl: '/static/img/mice/marker-active.svg',
                iconSize: [34, 50],
                iconAnchor: [17, 45],
                tooltipAnchor: [0, -50],
            })
        },
        special: {
            default: L.icon({
                iconUrl: '/static/img/mice/marker-special.svg',
                iconSize: [34, 50],
                iconAnchor: [17, 45],
                tooltipAnchor: [0, -50],
            }),
            active: L.icon({
                iconUrl: '/static/img/mice/marker-special-active.svg',
                iconSize: [34, 50],
                iconAnchor: [17, 45],
                tooltipAnchor: [0, -50],
            })
        }
    };
}

function getMarkerModification(id) {
    return $.grep(markerModifications, function (modification) {
        return modification.id === id;
    })[0] || null;
}

function getPredefinedDataset(prefix, $element) {
    let result = {};
    $.each($element.data(), function (key, value) {
        if (key.startsWith(prefix)) {
            let newKey = key.replace(prefix, "");
            newKey = newKey.charAt(0).toLowerCase() + newKey.slice(1);
            result[newKey] = value;
        }
    });
    return result;
}